export enum NewsStatus {
    Draft = 'Draft',
    Published = 'Published',
    Archieved = 'Archieved'
}
